'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _lib = require('helpers/lib');

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The card component for Shop Collection.
 * @version 1.0.1
 * @author Khoa Tran
 */
var CollectionCardMobile = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CollectionCardMobile, _Component);

  function CollectionCardMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CollectionCardMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CollectionCardMobile.__proto__ || (0, _getPrototypeOf2.default)(CollectionCardMobile)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _this.handlePress = function (e) {
      var onPress = _this.props.onPress;

      if (onPress) onPress(e);
      var _this$props = _this.props,
          tracking = _this$props.tracking,
          item = _this$props.item,
          manualTrack = _this$props.manualTrack;

      console.log(item);
      if (manualTrack) manualTrack((0, _extends3.default)({}, tracking, { label: item.name }));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CollectionCardMobile, [{
    key: 'render',
    value: function render() {
      var styles = require('./CollectionCardMobile.scss');
      var _props = this.props,
          item = _props.item,
          className = _props.className;

      var itemLink = 'bo-suu-tap/' + item.handle;
      return _react2.default.createElement(
        'div',
        { className: styles.cardWrapper + ' ' + (className || '') },
        _react2.default.createElement(
          'div',
          { className: styles.card },
          item.image && _react2.default.createElement(
            'div',
            { className: styles.cardImgWrapper },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                className: styles.cardImg,
                to: itemLink,
                onClick: this.handlePress
              },
              _react2.default.createElement(
                _reactLazyload2.default,
                { height: 185 },
                _react2.default.createElement('img', {
                  src: (0, _lib.getUrlImage)(item.image),
                  alt: item.name,
                  onError: this.onErrorImage
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: styles.title, to: itemLink },
              item.name
            )
          )
        )
      );
    }
  }]);
  return CollectionCardMobile;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  className: _react.PropTypes.string,
  tracking: _react.PropTypes.object,
  onPress: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2);
exports.default = CollectionCardMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Box/CollectionCardMobile.js
// module id = 1539
// module chunks = 0